import { Injectable, Inject } from '@angular/core';
import { BaseDO } from './base.model';


export class PersonEmploymentDO {
  public id: Number = null;

  public occupationCd: String = null;

  public industryCd: String = null;

  public natureOfDutyCd: String = null;

  public occupationClassCd: String = null;

  public montlyIncome: any = null;

  public yearlyIncomeRangeCd: any = null;

  public income: any = null;

  public getId(): Number {
    return this.id;
  }

  public setId(id: Number) {
    this.id = id;
  }

  public getOccupationCd(): String {
    return this.occupationCd;
  }

  public setOccupationCd(occupationCd: String) {
    this.occupationCd = occupationCd;
  }

  public getIndustryCd(): String {
    return this.industryCd;
  }

  public setIndustryCd(industryCd: String) {
    this.industryCd = industryCd;
  }

  public getNatureOfDutyCd(): String {
    return this.natureOfDutyCd;
  }

  public setNatureOfDutyCd(natureOfDutyCd: String) {
    this.natureOfDutyCd = natureOfDutyCd;
  }

  public getOccupationClassCd(): String {
    return this.occupationClassCd;
  }

  public setOccupationClassCd(occupationClassCd: String) {
    this.occupationClassCd = occupationClassCd;
  }

  public getMontlyIncome(): any {
    return this.montlyIncome;
  }

  public setMontlyIncome(montlyIncome: any) {
    this.montlyIncome = montlyIncome;
  }

   public getYearlyIncomeRangeCd(): any {
    return this.yearlyIncomeRangeCd;
  }

  public setYearlyIncomeRangeCd(yearlyIncomeRangeCd: any) {
    this.yearlyIncomeRangeCd = yearlyIncomeRangeCd;
  }

  public getIncome(): any {
    return this.income;
  }

  public setIncome(income: any) {
    this.income = income;
  }

}
